
import { createVuetify } from 'vuetify'
import { VAutocomplete, VBtn, VCard, VCardActions, VCheckbox, VFileInput, VList, VSelect, VSheet, VSwitch, VTextarea, VTextField } from 'vuetify/lib/components/index.mjs';
// import * as components from 'vuetify/components'
// import * as directives from 'vuetify/directives'
import colors from 'vuetify/util/colors';
import '@mdi/font/css/materialdesignicons.css';
import { VNumberInput } from 'vuetify/lib/labs/components.mjs';

const darkBodyColor = '#091548';
const textColorType = {
    'basic': '',
    'surface': '',
    'surface-action': '',
    // 'surface-action': '',
};
const textColor = {
    light:{
        base: '#0d1f4c',
        light: '#56658a',
        muted: '#56658a',
        btn:{
            base:{
                primary: '#ffffff',
                secondary: '#ffffff',
                info: '#ffffff',
                success: '#ffffff',
                warning: '#ffffff',
                danger: '#ffffff',
                error: '#ffffff',
            },
            dark:{
                primary: '#000000',
                secondary: '#000000',
                info: '#000000',
                success: '#000000',
                warning: '#000000',
                danger: '#000000',
                error: '#000000',
            }
        }
    },
    dark:{
        base: '#e1e5ec',
        light: '#e1e5ec',
        muted: '#e1e5ec',
        btn:{
            base:{
                primary: '#ffffff',
                secondary: '#ffffff',
                info: '#ffffff',
                success: '#ffffff',
                warning: '#ffffff',
                danger: '#ffffff',
                error: '#ffffff',
            },
            dark:{
                primary: '#000000',
                secondary: '#000000',
                info: '#000000',
                success: '#000000',
                warning: '#000000',
                danger: '#000000',
                error: '#000000',
            }
        }
    },
};

export default createVuetify({
    aliases: {
        VCardActionsDefault: VCardActions,
        VCardActionsForm: VCardActions,
        VCardActionsModal: VCardActions,
        VCardActionsFormModal: VCardActions,

        VSheetPlain: VSheet,

        VBtnPlain: VBtn,
        VBtnIcon: VBtn,
        VBtnIconPlain: VBtn,
        VBtnIconText: VBtn,
        VBtnIconPill: VBtn,
        VBtnIconTextPill: VBtn,
        VBtnIconOutlined: VBtn,
        VBtnIconOutlinedPill: VBtn,
        VBtnInput: VBtn,
        VBtnInputComfortable: VBtn,
        VBtnInputCompact: VBtn,
        VBtnModal: VBtn,

        VBtnV1: VBtn,
        VTextFieldV1: VTextField,
        VTextareaV1: VTextarea,
        VNumberInputV1: VNumberInput,
        VFileInputV1: VFileInput,
        VSwitchV1: VSwitch,
        VCheckboxV1: VCheckbox,
        VSelectV1: VSelect,
        VAutocompleteV1: VAutocomplete,
    },
    defaults:{
        global:{
            ripple: false,
        },
        VTooltip:{
            location: 'top'
        },
        VTextField:{
            variant: "outlined",
        },
        VBtn:{
            color: 'primary',
            variant: 'flat',
            rounded: 'lg',
        },
        VBtnGroup:{
            VBtn:{
                rounded: undefined,
            },
        },
        VBtnPlain:{
            color: 'primary',
            variant: 'plain',
        },
        VBtnIcon:{
            color: 'btn-secondary',
            variant: 'flat',
            rounded: 'lg',
            density: "comfortable",
            icon: true,
        },
        VBtnIconPlain:{
            color: 'btn-secondary',
            variant: 'plain',
            density: "comfortable",
            icon: true,
        },
        VBtnIconText:{
            color: 'secondary',
            variant: 'text',
            rounded: 'lg',
            density: "comfortable",
            icon: true,
        },
        VBtnIconOutlined:{
            color: 'secondary',
            variant: 'outlined',
            rounded: 'lg',
            density: "comfortable",
            icon: true,
        },
        VBtnIconPill:{
            color: 'btn-secondary',
            variant: 'flat',
            rounded: 'pill',
            density: "comfortable",
            icon: true,
        },
        VBtnIconTextPill:{
            color: 'secondary',
            variant: 'text',
            rounded: 'pill',
            density: "comfortable",
            icon: true,
        },
        VBtnIconOutlinedPill:{
            color: 'secondary',
            variant: 'outlined',
            rounded: 'pill',
            density: "comfortable",
            icon: true,
        },
        VBtnInput:{
            color: 'primary',
            variant: 'flat',
            density: "default",
            class: "match-input",
        },
        VBtnInputCompact:{
            color: 'primary',
            variant: 'flat',
            density: "default",
            class: "match-input-compact",
        },
        VBtnInputComfortable:{
            color: 'primary',
            variant: 'flat',
            density: "default",
            class: "match-input-comfortable",
        },
        VBtnModal:{
            color: 'primary',
            variant: 'flat',
            rounded: 'lg',
        },
        VCard:{
            elevation: 'card',
            rounded: "lg",
            VCardActions:{
            },
            
        },
        VCardActionsDefault:{
            class: "bg-card-action justify-end px-4 py-4", 
            VBtn:{
                variant: 'flat',
                slim: false,
            }
        },
        VCardActionsForm:{
            class: "bg-card-action justify-end px-6 py-4", 
            VBtn:{
                variant: 'flat',
                slim: false,
            }
        },
        VCardActionsModal:{
            class: "bg-card-action justify-end px-3 py-3", 
            VBtn:{
                variant: 'flat',
                slim: false,
            }
        },
        VCardActionsFormModal:{
            class: "bg-card-action justify-end px-6 py-3", 
            VBtn:{
                variant: 'flat',
                slim: false,
            }
        },
        VSheet:{
            color: "surface-light",
            rounded: "lg",
        },
        VSheetPlain:{
            
        },
        VMenu:{
            transition: "slide-x-transition",
            offset: '5px',
            VList:{
                'minWidth': '180px',
                density: 'compact',
                variant: 'flat',
                elevation: 0,
                border: 'sm',
                rounded: 'lg',
                
                nav: true,
            }
        },
        VBtnV1:{
            density: 'default',
            class: 'match-input',
            color: 'primary',
            variant: 'flat',
            rounded: 'lg',
        },
        VTextFieldV1:{
            hideDetails: 'auto',
            density: 'default',
            variant: 'outlined',
        },
        VNumberInputV1:{
            hideDetails: 'auto',
            density: 'default',
            variant: 'outlined',
            inset: true,
            VBtn:{
                variant: 'plain',
                density: 'comfortable',
                color: 'secondary',
            }
        },
        VTextareaV1:{
            hideDetails: 'auto',
            density: 'default',
            variant: 'outlined',
            rows: 3,
        },
        VFileInputV1:{
            hideDetails: 'auto',
            density: 'default',
            variant: 'outlined',
            prependIcon: '',
        },
        VSwitchV1:{
            hideDetails: 'auto',
            density: 'default',
            color: "primary",
        },
        VCheckboxV1:{
            hideDetails: 'auto',
            density: 'default',
            color: "primary",
        },
        VSelectV1:{
            hideDetails: 'auto',
            density: 'default',
            variant: "outlined",
        },
        VAutocompleteV1:{
            hideDetails: 'auto',
            density: 'default',
            variant: "outlined",
        },
    },
    theme: {
        defaultTheme: 'light',
        themes: {
        light: {
            dark: false,
            colors: {
            'background': '#f0f3f8',
            'on-background': textColor.light.base,
            'surface': '#ffffff',
            'on-surface': textColor.light.base,
            'surface-bright': '#fafafa',
            'on-surface-bright': textColor.light.base,
            'surface-light': '#e6eaf1',
            'on-surface-light': textColor.light.base,
            'surface-dark': '#d4dff0',
            'on-surface-dark': textColor.light.base,
            'surface-variant': '#8bacdf',
            'on-surface-variant': textColor.light.base,

            'base': textColor.light.base,
            'body': '#f0f3f8',
            'on-body': textColor.light.base,
            'link': colors.blue.darken3,
            'light': colors.grey.lighten3,
            'topbar': '#ffffff',
            'divider': '#2c435d',
            'divider-light': '#a6b2c1',
            'card-action': '#f6f8fb',
            'white': '#ffffff',
            'black': '#000000',
            

            'primary': colors.blue.darken1,
            'on-primary': textColor.light.btn.base.primary,
            'primary-light': colors.blue.lighten2,
            'on-primary-light': textColor.light.btn.dark.primary,
            'primary-dark': colors.blue.darken3,
            'on-primary-dark': textColor.light.btn.base.primary,
            'primary-lightest': '#d3e6ff', // colors.blue.lighten5,
            'on-primary-lightest': textColor.light.base,

            'info': colors.indigo.darken1,
            'on-info': textColor.light.btn.base.info,
            'info-light': colors.indigo.lighten2,
            'on-info-light': textColor.light.btn.dark.info,
            'info-dark': colors.indigo.darken3,
            'on-info-dark': textColor.light.btn.base.info,
            'info-lightest': '#e1deff', // colors.indigo.lighten4,
            'on-info-lightest': textColor.light.base,

            'secondary': '#5d6f83', //colors.grey.darken3, 
            'on-secondary': textColor.light.btn.base.secondary,
            'btn-secondary': '#5d6f83',
            'btn-on-secondary': textColor.light.btn.base.secondary,
            'secondary-light': '#a6b2c1', 
            'on-secondary-light': textColor.light.btn.base.secondary, 

            'success': colors.green.darken1, 
            'on-success': textColor.light.btn.base.success, 
            'success-light': colors.green.lighten2, 
            'on-success-light': textColor.light.btn.dark.success, 
            'success-lightest': colors.green.lighten4, 
            'on-success-lightest': textColor.light.base, 

            'warning': colors.orange.darken1, 
            'on-warning': textColor.light.btn.base.warning, 
            'warning-light': colors.orange.lighten2, 
            'on-warning-light': textColor.light.btn.dark.warning, 
            'warning-lightest': colors.orange.lighten4, 
            'on-warning-lightest': textColor.light.base, 

            'danger': colors.red.darken1, 
            'on-danger': textColor.light.btn.base.danger, 
            'danger-light': colors.red.lighten3, 
            'on-danger-light': textColor.light.btn.dark.danger, 
            'danger-lightest': colors.red.lighten5, 
            'on-danger-lightest': textColor.light.base, 

            'error': colors.red.darken1, 
            'on-error': textColor.light.btn.base.error, 
            'error-light': colors.red.lighten3, 
            'on-error-light': textColor.light.btn.dark.error, 
            'error-lightest': colors.red.lighten5, 
            'on-error-lightest': textColor.light.base, 
            },
            variables:{
                'border-color': textColor.light.base,
            }
        },
        dark: {
            dark: true,
            colors: {
                'background': '#06162b',
                'on-background': textColor.dark.base,
                'surface': '#152741',
                'on-surface': textColor.dark.base,
                'surface-bright': '#1c2f4a',
                'on-surface-bright': textColor.dark.base,
                'surface-light': '#1c2e47',
                'on-surface-light': textColor.dark.base,
                'surface-dark': '#1c3456',
                'on-surface-dark': textColor.dark.light,
                'surface-variant': '#2d3e72',
                'on-surface-variant': textColor.dark.light,

                'base': textColor.dark.base,
                'body': '#06162b',
                'on-body': textColor.dark.base,
                'link': colors.blue.base,
                'light': '#2e425e',
                'topbar': '#0e1d32',
                'divider': colors.grey.lighten2,
                'divider-light': colors.grey.base,
                'card-action': '#1c2e47',
                'white': '#ffffff',
                'black': '#000000',
                

                'primary': colors.blue.lighten1,
                'on-primary': textColor.dark.btn.base.primary,
                'primary-light': colors.blue.darken2,
                'on-primary-light': textColor.dark.btn.dark.primary,
                'primary-dark': colors.blue.lighten3,
                'on-primary-dark': textColor.dark.btn.base.primary,
                'primary-lightest': '#0d2953',
                'on-primary-lightest': textColor.dark.base,

                'info': colors.indigo.lighten2,
                'on-info': textColor.dark.btn.base.info,
                'info-light': colors.indigo.lighten2,
                'on-info-light': textColor.dark.btn.dark.info,
                'info-dark': colors.indigo.darken3,
                'on-info-dark': textColor.dark.btn.base.info,
                'info-lightest': '#1e224a',
                'on-info-lightest': textColor.dark.base,

                'secondary': '#a5bacb', 
                'on-secondary': textColor.dark.btn.base.secondary,
                'btn-secondary': '#2e425e', 
                'btn-on-secondary': textColor.dark.btn.base.secondary,
                'secondary-light': '#738a9d', 
                'on-secondary-light': textColor.dark.btn.dark.secondary, 

                'success': colors.green.darken1, 
                'on-success': textColor.dark.btn.base.success, 
                'success-light': colors.green.lighten2, 
                'on-success-light': textColor.dark.btn.dark.success, 
                'success-lightest': '#133015', 
                'on-success-lightest': textColor.dark.base, 

                'warning': colors.orange.darken1, 
                'on-warning': textColor.dark.btn.base.warning, 
                'warning-light': colors.orange.lighten2, 
                'on-warning-light': textColor.dark.btn.dark.warning, 
                'warning-lightest': '#472c09', 
                'on-warning-lightest': textColor.dark.base, 

                'danger': colors.red.lighten1, 
                'on-danger': textColor.dark.btn.base.danger, 
                'danger-light': colors.red.lighten3, 
                'on-danger-light': textColor.dark.btn.dark.danger, 
                'danger-lightest': '#471309', 
                'on-danger-lightest': textColor.dark.base, 

                'error': colors.red.lighten1, 
                'on-error': textColor.dark.btn.base.error, 
                'error-light': colors.red.lighten3, 
                'on-error-light': textColor.dark.btn.dark.error, 
                'error-lightest': '#471309', 
                'on-error-lightest': textColor.dark.base,
            },
            variables:{
                'border-color': textColor.dark.base,
            }
        },
        },
    },
//   components: components,
//   directives: directives
})